module.exports = __webpack_public_path__ + "static/media/que-hacer-en-recoleta.c4a5012a.md";